import { AxiosInstance, AxiosRequestConfig } from 'axios';

import { axios } from '../../../../api/axios-instance';
import { userPixelsHistoryEndpoints } from '../../../../constants';
import { DateFilter } from '../../../../enum/date-filter.enum';
import { PaginationRequest } from '../../../../types/pagination-request';
import { SortRequest } from '../../../../types/sort-request';
import { UserPixelsHistoryResponse } from '../../../user/schemas/user-pixels-history.schema';

class UserPixelsHistoryApi {
  #requestInstance: AxiosInstance;

  constructor(axiosInstance: AxiosInstance) {
    this.#requestInstance = axiosInstance;
  }

  getUserHistory = async (
    userId: number,
    data?: PaginationRequest & SortRequest<DateFilter>,
    config?: AxiosRequestConfig
  ): Promise<UserPixelsHistoryResponse> => {
    return this.#requestInstance.get(userPixelsHistoryEndpoints.getUserHistoryById(userId), {
      params: data,
      ...config,
    });
  };
}

export const userPixelsHistoryApi = new UserPixelsHistoryApi(axios);
